import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import TextField from '@mui/material/TextField';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import apiClient, { shouldRedirectToLogin, getErrorMessage } from '../services/api-client';
import Button from '@mui/material/Button';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Drawer from '@mui/material/Drawer';

import Paper from '@mui/material/Paper';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import InputBase from '@mui/material/InputBase';
import { alpha } from '@mui/material/styles';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
import CustomSnackbar from '../components/CustomSnackbar';

import { Navigate, useNavigate } from 'react-router-dom';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';

import AppConfig from '../services/app-config';

import { useSwipeable } from 'react-swipeable';
import { motion, AnimatePresence } from 'framer-motion';

import PersonOffIcon from '@mui/icons-material/PersonOff';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import LockIcon from '@mui/icons-material/Lock';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import Checkbox from '@mui/material/Checkbox';

import AuthService from '../services/auth';
import wsClient from '../services/ws';

const publicUrl = process.env.REACT_APP_PUBLIC_URL;

export default function UsersAdmin({setNavbarState, navbarState, window}) {
  const [users, setUsers] = React.useState([]);
  const [searchValue, setSearchValue] = React.useState('');
  const [loading, setLoading] = React.useState(true);
  const [tabValue, setTabValue] = React.useState('activo');
  const [redirect, setRedirect] = React.useState({ trigger: false, route: '/' }); 
  const navigate = useNavigate();
  const [connectedUsers, setConnectedUsers] = React.useState(0);
  const [newUserName, setNewUserName] = React.useState('');
  const [newUserLastName, setNewUserLastName] = React.useState('');
  const [newUserMode, setNewUserMode] = React.useState('pro');
  const [newUnitMode, setNewUnitMode] = React.useState('propia');
  const [newUserUnit, setNewUserUnit] = React.useState('');
  const [newUserUnitValid,setNewUserUnitValid] = React.useState({"error": false, "message": ""});
  const [newUserRole, setNewUserRole] = React.useState('habitante');
  const [newUserPhone, setNewUserPhone] = React.useState('');
  const [newUserEmail, setNewUserEmail] = React.useState('');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [drawerShow, setDrawerShow] = React.useState(false);
  const [sendInvite, setSendInvite] = React.useState(true);
  const [deleteUserDialog, setDeleteUserDialog] = React.useState(false);
  const [pwdResetDialog, setPwdResetDialog] = React.useState(false);
  const [userToDelete, setUserToDelete] = React.useState(null);
  const [userToReset, setUserToReset] = React.useState(null);
  const [modules, setModules] = React.useState({});
  const [showUnitMode, setShowUnitMode] = React.useState(false);
  const [drawerCTA, setDrawerCTA] = React.useState('Agregar');
  const [swipeDirection, setSwipeDirection] = React.useState(null);
  const [moreOptsDrawer, setMoreOptsDrawer] = React.useState(false);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const [accessRestrictModal, setAccessRestrictModal] = React.useState(false);
  const [selectedModules, setSelectedModules] = React.useState({});

  
  const filteredUsers = users.filter(user => {
    const q = String(searchValue || '').toLowerCase();
    const name = String(user?.name || '').toLowerCase();
    const lastname = String(user?.lastname || '').toLowerCase();
    const phone = String(user?.phone || '').toLowerCase();
    const unit = String(user?.unit || '').toLowerCase();
    const role = String(user?.role || '').toLowerCase();
    const username = String(user?.username || '').toLowerCase();

    return (
      name.includes(q)
      || lastname.includes(q)
      || phone.includes(q)
      || unit.includes(q)
      || role.includes(q)
      || username.includes(q)
    );
  });

  const getInitials = React.useCallback((user) => {
    const first = (user?.name || '').trim().charAt(0);
    const last = (user?.lastname || '').trim().charAt(0);
    const initials = `${first}${last}`.toUpperCase();
    return initials || 'U';
  }, []);

  const getRoleLabel = React.useCallback((role) => {
    const r = String(role || '').toLowerCase();
    if (r === 'admin') return 'Admin';
    if (r === 'receptor') return 'Receptor';
    if (r === 'habitante') return 'Residente';
    return role || '—';
  }, []);

  const getRoleChipSx = React.useCallback((role) => {
    const r = String(role || '').toLowerCase();

    if (r === 'habitante') {
      return {
        bgcolor: (theme) => alpha(theme.palette.success.main, theme.palette.mode === 'dark' ? 0.25 : 0.12),
        color: (theme) => theme.palette.success.main,
      };
    }

    if (r === 'admin' || r === 'receptor') {
      return {
        bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.35 : 0.12),
        color: (theme) => (theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main),
      };
    }

    return {
      bgcolor: (theme) => alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.18 : 0.06),
      color: 'text.secondary',
    };
  }, []);

  const fabStyle = {
    position: 'fixed',
    bottom: 96,
    right: 20,
  };

  const handleDrawerToggle = () => {
    setDrawerShow((prevState) => !prevState);
    if (!drawerShow) {
      resetDrawer();
    }
  };

  const roleDict = {
    "Habitante": "habitante",
    "Receptor": "receptor",
    "Admin": "admin"
  }

  var regex = null
  if (AppConfig.getLocal("unit_regex")) {
    regex = new RegExp(AppConfig.getLocal("unit_regex"));
  }

  const handleModeChange = (value) => {
    setNewUserMode(value);
    if (value === "inq") {
      setNewUnitMode("rentada");
    }
  }

  const handleUnitChange = (event) => {
    if (AppConfig.getLocal("unit_regex") && newUserRole === 'habitante') {
      var text = event.target.value;
      if (AppConfig.getLocal("unit_sample")) {
        var complement_length = AppConfig.getLocal("unit_sample").length - text.length ;
        var complement_text = AppConfig.getLocal("unit_sample").slice(-complement_length);
        if (complement_length === 0) {
          complement_text = "" ;
          setShowUnitMode(true);
        }
        text = `${text}${complement_text}`
      }
      if (!regex.test(text)) {
        setNewUserUnitValid({"error": true, "message": `Formato Incorrecto ej. ${AppConfig.getLocal("unit_sample")}`});
        setShowUnitMode(false);
      } else {
        setNewUserUnitValid({"error": false, "message": ""});
      }
    } 
    setNewUserUnit(event.target.value);
  }

  const handleNewUser = () => {
    setNewUserName("");
    setNewUserLastName("");
    setNewUserPhone("");
    setNewUserEmail("");
    setNewUserRole("habitante");
    setNewUserUnit("");
    setDrawerCTA('Agregar');
    setSendInvite(true);
    setDrawerShow(true);
    setNewUserMode('pro');
    setNewUnitMode('propia');
    setShowUnitMode(false);
  }

  const handleEditUser = (username) => {
    const user = users.find(user => user.username === username);
    setNewUserName(user.name);
    setNewUserLastName(user.lastname);
    setNewUserPhone(user.phone);
    setNewUserEmail(user.username);
    setNewUnitMode(user.unit_data.mode);
    setNewUserRole(roleDict[user.role]);
    setNewUserUnit(user.unit);
    setDrawerCTA('Editar');
    setSendInvite(false);
    setDrawerShow(true);
    setNewUserMode(user.mode);
    setShowUnitMode(true);
  }

  const fetchUsers = (type='activo') => {
    if (type === "activo"){
        apiClient.get('users/allusersadmin', {}, { action: 'fetch_all_users_admin' })
         .then((response) => {
           if (response.status === 200) {
             setUsers(response.data.data)
             setLoading(false)
           }
         })
         .catch(error => {
           console.error(error);
           if (error.response.data.code === 401) {
              setRedirect({ trigger: true, route: '/login' })
            }
         })} else {
        apiClient.get('users/allinvitedadmin', {}, { action: 'fetch_all_invited_admin' })
        .then((response) => {
            if (response.status === 200) {
            setUsers(response.data.data)
            setLoading(false)
            }
        })
        .catch(error => {
            console.error(error);
            if (error.response.data.code === 401) {
              setRedirect({ trigger: true, route: '/login' })
            }
        })

         }
  }

  const fetchAvailableModules = () => {
    apiClient.get('modules/available', {}, { action: 'fetch_available_modules' })
      .then((response) => {
        if (response.status === 200) {
          setModules(response.data.data)
        }
      })
  }

  const createNewUser = () => {
    var localNewUserUnit;
    if(!['habitante', 'receptor', 'admin'].includes(newUserRole)){
      setSnackbarSeverity("warning")
      setSnackbarMessage('El rol solo puede ser admin, receptor o habitante');
      setSnackbarOpen(true);
      return;
    }
    if (newUserName === ""){
      setSnackbarSeverity("warning")
      setSnackbarMessage('Porfavor ingresa el nombre del usuario.');
      setSnackbarOpen(true);
      return;
    }
    if (newUserLastName === ""){
      setSnackbarSeverity("warning")
      setSnackbarMessage('Porfavor ingresa el apellido del usuario.');
      setSnackbarOpen(true);
      return;
    }
    if (newUserPhone === ""){
      setSnackbarSeverity("warning")
      setSnackbarMessage('Porfavor ingresa el numero de telefono del usuario.');
      setSnackbarOpen(true);
      return;
    }
    if (newUserEmail === ""){
      setSnackbarSeverity("warning")
      setSnackbarMessage('Porfavor ingresa el correo del usuario.');
      setSnackbarOpen(true);
      return;
    }
    if (newUserRole === ""){
      setSnackbarSeverity("warning")
      setSnackbarMessage('Porfavor ingresa el nombre del usuario.');
      setSnackbarOpen(true);
    } else if (newUserRole === 'receptor')  {
      localNewUserUnit = 'Recepcion'
    } else if (newUserRole === 'admin')  {
      localNewUserUnit = 'Administracion'
    } else if (newUserRole === 'habitante')  {
      localNewUserUnit = newUserUnit
    }

    if (localNewUserUnit === ""){
      setSnackbarSeverity("warning")
      setSnackbarMessage('Porfavor ingresa el la unidad del usuario.');
      setSnackbarOpen(true);
      return;
    }

    if (newUserMode === "" || newUserMode === "ninguna" && newUserRole === 'habitante'){
      setSnackbarSeverity("warning")
      setSnackbarMessage('Porfavor ingresa la modalidad del usuario.');
      setSnackbarOpen(true);
      return;
    }

    if (AppConfig.getLocal("unit_regex") && newUserRole === 'habitante') {
      if (!regex.test(localNewUserUnit)) {
        setSnackbarSeverity("warning")
        setSnackbarMessage(`La unidad no cumple con el formato esperado de apartamentos, ej. ${AppConfig.getLocal("unit_sample")}`);
        setSnackbarOpen(true);
        return;
      }
    }

    const data = {
      name: newUserName,
      lastname: newUserLastName,
      unit: localNewUserUnit,
      role: newUserRole,
      phone: newUserPhone,
      email: newUserEmail,
      sendMail: sendInvite,
      action: drawerCTA.toLowerCase(),
      mode: newUserMode,
      unitMode: newUnitMode
    }

    apiClient.post('invite/user', data, {}, { action: 'invite_user' })
      .then((response) => {
        if (response.status === 200) {
          setSnackbarSeverity("success")
          if (drawerCTA === "Agregar"){
            setSnackbarMessage('Usuario creado exitosamente.');
            setTabValue('invitado');
            fetchUsers('invitado');
          } else if (drawerCTA === "Editar"){
            setSnackbarMessage('Usuario editado exitosamente.');
            setTabValue('activo');
            fetchUsers('activo');
          }
          setDrawerShow(false);
          setSnackbarOpen(true);
        }
      })
      .catch((err) => {
        if (err.response?.data?.code === 409) {
          setSnackbarSeverity("error")
          setSnackbarMessage('El usuario ya existe en la base de datos.');
          setSnackbarOpen(true);
        } else {
        console.error(err);
        setSnackbarSeverity("error")
        setSnackbarMessage('Tuvimos un error intenta de nuevo en otro momento.');
        setSnackbarOpen(true);}
      });
  };

  const handleSendInviteSwitch = (event) => {
    setSendInvite(event.target.checked);
  };

  const resetDrawer = () => {
    setNewUserName("");
    setNewUserLastName("");
    setNewUserPhone("");
    setNewUserEmail("");
    setNewUserRole("habitante");
    setNewUserUnit("");
    setNewUserMode('pro');
    setNewUnitMode('propia');
    setShowUnitMode(false);
  };

  const newUserDrawer = (
    <Box
      sx={{
        width: '100%',
        height: { xs: '100dvh', sm: '100vh' },
        bgcolor: 'background.default',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ px: 2.5, pt: 2.25, pb: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <IconButton
            onClick={() => {
              handleDrawerToggle();
            }}
            sx={{ width: 40, height: 40, ml: -1, color: 'text.primary' }}
          >
            <ArrowBackIosNewIcon sx={{ fontSize: 20 }} />
          </IconButton>
          <Typography sx={{ fontSize: 22, fontWeight: 900, letterSpacing: '-0.02em', color: 'text.primary' }}>
            {drawerCTA === 'Agregar' ? 'Nuevo Usuario' : 'Editar Usuario'}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ flex: 1, overflowY: 'auto', px: 3, pb: 2 }}>
        <Box sx={{ mb: 2 }}>
          <Typography sx={{ fontSize: 18, fontWeight: 900, color: 'text.primary' }}>
            Datos Personales
          </Typography>
          <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.secondary', mt: 0.5 }}>
            Por favor, ingrese la información básica del usuario.
          </Typography>
        </Box>

        <>
            <TextField
              fullWidth
              value={newUserName}
              id="name"
              label="Nombre"
              variant="outlined"
              onChange={(e) => setNewUserName(e.target.value)}
              sx={{ mb: 2 }}
              inputProps={{ style: { height: 24 } }}
            />
            <TextField
              fullWidth
              value={newUserLastName}
              id="lastname"
              label="Apellido"
              variant="outlined"
              onChange={(e) => setNewUserLastName(e.target.value)}
              sx={{ mb: 2 }}
              inputProps={{ style: { height: 24 } }}
            />
            <TextField
              fullWidth
              value={newUserEmail}
              id="email"
              label="Correo Electrónico"
              variant="outlined"
              disabled={drawerCTA === 'Editar'}
              onChange={(e) => setNewUserEmail(e.target.value)}
              sx={{ mb: 2 }}
              inputProps={{ style: { height: 24 } }}
            />
            <TextField
              fullWidth
              value={newUserPhone}
              id="phone"
              label="Teléfono"
              variant="outlined"
              onChange={(e) => setNewUserPhone(e.target.value)}
              sx={{ mb: 2 }}
              inputProps={{ style: { height: 24 } }}
            />

            <FormControl sx={{ mb: 2 }} fullWidth>
              <InputLabel id="role-select-label">Rol</InputLabel>
              <Select
                labelId="role-select-label"
                id="role-select"
                value={newUserRole}
                label="Rol"
                onChange={(e) => setNewUserRole(e.target.value)}
              >
                <MenuItem value="habitante">Habitante</MenuItem>
                <MenuItem value="receptor">Receptor</MenuItem>
                <MenuItem value="admin">Administrador</MenuItem>
              </Select>
            </FormControl>

            {drawerCTA === 'Agregar' && (
              <FormGroup sx={{ mb: 1 }}>
                <FormControlLabel
                  control={<Switch onChange={handleSendInviteSwitch} checked={sendInvite} />}
                  label="Enviar Correo de Invitación"
                />
              </FormGroup>
            )}
        </>

        {newUserRole === 'habitante' && (
          <>
            <Box sx={{ mt: 2.5, mb: 2 }}>
              <Typography sx={{ fontSize: 18, fontWeight: 900, color: 'text.primary' }}>
                Unidad
              </Typography>
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.secondary', mt: 0.5 }}>
                Agregue la información de unidad y modalidad.
              </Typography>
            </Box>

            <TextField
              fullWidth
              value={newUserUnit}
              id="unit"
              label={AppConfig.get('unit_type')}
              variant="outlined"
              onChange={(e) => handleUnitChange(e)}
              helperText={newUserUnitValid.message}
              error={newUserUnitValid.error}
              sx={{ mb: 2 }}
              inputProps={{ style: { height: 24 } }}
            />

            <FormControl sx={{ mb: 2 }} fullWidth>
              <InputLabel id="mode-select-label">Modalidad</InputLabel>
              <Select
                labelId="mode-select-label"
                id="mode-select"
                value={newUserMode}
                label="Modalidad"
                onChange={(e) => handleModeChange(e.target.value)}
              >
                <MenuItem value="pro">Propietario</MenuItem>
                <MenuItem value="inq">Inquilino</MenuItem>
                {drawerCTA !== 'Agregar' && <MenuItem value="ninguna">Sin Configurar</MenuItem>}
              </Select>
            </FormControl>

            {showUnitMode && (
              <FormControl sx={{ mb: 2 }} fullWidth>
                <InputLabel id="unit-usage-label" shrink>{`Uso de ${newUserUnit}`}</InputLabel>
                <Select
                  labelId="unit-usage-label"
                  id="unit-usage-select"
                  value={newUnitMode}
                  label={`Uso de ${newUserUnit}`}
                  onChange={(e) => setNewUnitMode(e.target.value)}
                  displayEmpty
                >
                  <MenuItem value="ninguna" disabled>Seleccione una opción</MenuItem>
                  <MenuItem value="rentada">En Renta</MenuItem>
                  <MenuItem value="propia" disabled={newUserMode === 'inq'}>Uso Propio</MenuItem>
                  <MenuItem value="airbnb" disabled={newUserMode === 'inq'}>AirBnb</MenuItem>
                </Select>
              </FormControl>
            )}
          </>
        )}
      </Box>

      <Box sx={{ p: 3, borderTop: '1px solid', borderColor: (theme) => alpha(theme.palette.divider, 0.5) }}>
        <Button
          fullWidth
          size="large"
          variant="contained"
          color="secondary"
          onClick={() => {
            createNewUser();
          }}
          sx={(theme) => ({
            py: 1.5,
            borderRadius: '10px',
            fontWeight: 900,
            textTransform: 'none',
            bgcolor: theme.palette.success.main,
            color: theme.palette.getContrastText(theme.palette.success.main),
            '&:hover': { bgcolor: theme.palette.success.dark },
          })}
        >
          {drawerCTA}
        </Button>
      </Box>
    </Box>
  );

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => {
      if (tabValue === 'activo') {
        setSwipeDirection('left');
        setTabValue('invitado');
        fetchUsers('invitado');
      }
    },
    onSwipedRight: () => {
      if (tabValue === 'invitado') {
        setSwipeDirection('right');
        setTabValue('activo');
        fetchUsers('activo');
      }
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });

  const pageVariants = {
    enter: (direction) => {
      return {
        x: direction === 'left' ? 1000 : -1000,
        opacity: 0
      };
    },
    center: {
      x: 0,
      opacity: 1
    },
    exit: (direction) => {
      return {
        x: direction === 'left' ? -1000 : 1000,
        opacity: 0
      };
    }
  };

  const pageTransition = {
    type: 'tween',
    ease: 'anticipate',
    duration: 0.5
  };

  React.useEffect(() => {
    fetchUsers(tabValue)
    fetchAvailableModules()
    setNavbarState({...navbarState, showBack: true, showOptions: false, showSearch: false})
  }, [])

  React.useEffect(() => {
    const currentOrg = AuthService.getCurrentUserOrg?.() || '';

    apiClient.get('admin/status', {}, { action: 'fetch_admin_status_users_admin' })
      .then((response) => {
        const connections = response?.data?.data?.connections ?? response?.data?.data?.connected_users;
        if (typeof connections === 'number') {
          setConnectedUsers(connections);
        }
      })
      .catch(() => {
        // ignore
      });

    if (!currentOrg) {
      return undefined;
    }

    const offConnectedUsers = wsClient.on('connected_users', (msg) => {
      const eventOrg = msg?.data?.org;
      const connections = msg?.data?.connections;

      if (!eventOrg || eventOrg.toLowerCase() !== String(currentOrg).toLowerCase()) {
        return;
      }

      if (typeof connections === 'number') {
        setConnectedUsers(connections);
      }
    });

    return () => {
      if (typeof offConnectedUsers === 'function') {
        offConnectedUsers();
      }
    };
  }, []);

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const closeDeleteUserDialog = () => {
    setDeleteUserDialog(false);
  }

  const showDeleteUserDialog = (user) => {
    user['user_id'] = user.invcode ? user.invcode : user.username;
    setUserToDelete(user);
    setDeleteUserDialog(true);
  }

  const showPwdResetDialog = (user) => {
    setUserToReset(user);
    setPwdResetDialog(true);
  }

  const closePwdResetDialog = () => {
    setPwdResetDialog(false);
  }
  
  
  const deleteUser = (userId) => {
    setLoading(true)
    setDeleteUserDialog(false);
    apiClient.post('delete/user', {"id": userId}, {}, { action: 'delete_user' })
      .then((response) => {
        if (response.status === 200) {
          setSnackbarSeverity("success")
          setSnackbarMessage('Usuario eliminado.');
          fetchUsers(tabValue);          
          setSnackbarOpen(true);
          setLoading(false)
          setMoreOptsDrawer(false);
          setSelectedUser(null);
        }
      })
      .catch((err) => {
        console.error(err);
        setSnackbarSeverity("error")
        setSnackbarMessage('Tuvimos un error intenta de nuevo en otro momento.');
        setSnackbarOpen(true);
      });
  };

  const resetPwd = (email) => {
    if (!email) {
      setSnackbarSeverity('warning');
      setSnackbarMessage('Correo inválido');
      setSnackbarOpen(true);
      setPwdResetDialog(false);
      return;
    }

    setLoading(true);
    setPwdResetDialog(false);
    apiClient.post('request/reset/login', { email }, {}, { action: 'request_reset_login' })
      .then((response) => {
        AppConfig.parseResponse(response);
        if (response.status === 200) {
          setSnackbarSeverity('success');
          setSnackbarMessage('Correo de restablecimiento enviado.');
          setSnackbarOpen(true);
        }
      })
      .catch((err) => {
        if (shouldRedirectToLogin(err)) {
          setRedirect({ trigger: true, route: '/login' });
          return;
        }
        setSnackbarSeverity('error');
        setSnackbarMessage(getErrorMessage(err) || 'Error al enviar el correo de restablecimiento.');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const shareInvite = (invcode) => {
    if (navigator.share) {
      navigator.share({
         title: 'Registrate en MiGarita.Online',
         url: `${publicUrl}/registro?invcode=${invcode}`
      }).then(() => console.log('Successful share'))
        .catch((error) => console.log('Error sharing', error));
    } else {
      console.log('Share not supported on this browser, do it manually');
    }
  }

  const resendInvite = (invcode) => {
    setLoading(true)
    apiClient.post('invite/resend', {"invite_code": invcode}, {}, { action: 'resend_invite' })
      .then((response) => {
        if (response.status === 200) {
          setSnackbarSeverity("success")
          setSnackbarMessage('Correo de invitacion enviado.');
          setSnackbarOpen(true);
          setLoading(false)
        }
      })
      .catch((err) => {
        console.error(err);
        setSnackbarSeverity("error")
        setSnackbarMessage('Tuvimos un error intenta de nuevo en otro momento.');
        setSnackbarOpen(true);
        setLoading(false)
      });
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setLoading(true)
    fetchUsers(newValue);
  };

  const handleMoreOptions = (user) => {
    setSelectedUser(user);
    setMoreOptsDrawer(true);
  };

  const handleCloseMoreOpts = () => {
    setMoreOptsDrawer(false);
    setSelectedUser(null);
  };

  const handleModuleChange = (event) => {
    setSelectedModules({
      ...selectedModules,
      [event.target.name]: event.target.checked,
    });
  };

  const openAccessRestrictModal = (user) => {
    let modulesToRestrict = {}
    // Check if user.restricted_modules is an array
    if (Array.isArray(user.restricted_modules)) {
      // If it's an array, set each module to true
      user.restricted_modules.forEach(module => {
        modulesToRestrict[module] = true;
      });
    } else if (typeof user.restricted_modules === 'object') {
      // If it's already an object, use it directly
      modulesToRestrict = { ...user.restricted_modules };
    }
    
    setSelectedUser(user);
    setSelectedModules(modulesToRestrict);
    setAccessRestrictModal(true);
  };

  const closeAccessRestrictModal = () => {
    setAccessRestrictModal(false);
    setSelectedUser(null);
  };

  const saveAccessRestrictions = () => {
    console.log('Saving access restrictions for user:', selectedUser);
    console.log('Restricted modules:', selectedModules);
    apiClient.post('modules/restrict', {
      "username": selectedUser.username,
      "modules": selectedModules
    }, {}, { action: 'restrict_modules' })
    .then((response) => {
      AppConfig.parseResponse(response);
      if (response.status === 200) {
        setSnackbarSeverity("success");
        setSnackbarMessage('Accesos actualizados exitosamente.');
        setSnackbarOpen(true);
        closeAccessRestrictModal();
        setMoreOptsDrawer(false);
        fetchUsers(tabValue);
      }
    })
    .catch((err) => {
      console.error(err);
      setSnackbarSeverity("error");
      setSnackbarMessage('Error al actualizar los accesos.');
      setSnackbarOpen(true);
    });
  };

  const moreOptsDrawerContent = (
    <Card
    sx={{ 
      py: 3, 
      px: 2, 
      display: 'block', 
      marginLeft: 'auto', 
      marginRight: 'auto', 
      borderTopLeftRadius: "20px", 
      borderTopRightRadius: "20px", 
      borderBottomRightRadius: "0px", 
      borderBottomLeftRadius: "0px", 
      maxWidth: "550px",
      width: '100%' 
    }}>
      <CardContent>
        <Typography gutterBottom variant="h5" component="div" sx={{ mb: 2 }}>
          Mas Opciones para {selectedUser ? `${selectedUser.name} ${selectedUser.lastname}` : ''}
        </Typography>
        <List>
          <ListItem button onClick={() => openAccessRestrictModal(selectedUser)}>
            <ListItemIcon>
              <LockIcon />
            </ListItemIcon>
            <ListItemText primary="Restringir Accesos" />
          </ListItem>
          {/* <ListItem button onClick={() => showPwdResetDialog(selectedUser)}>
            <ListItemIcon>
              <KeyIcon />
            </ListItemIcon>
            <ListItemText primary="Reiniciar Contraseña" />
          </ListItem> */}
          <ListItem button onClick={() => showDeleteUserDialog(selectedUser)}>
            <ListItemIcon>
              <DeleteIcon />
            </ListItemIcon>
            <ListItemText primary="Eliminar Usuario" />
          </ListItem>
        </List>
      </CardContent>
      <CardActions>
        <Button size="medium" onClick={handleCloseMoreOpts} color="inherit" variant="outlined">Cerrar</Button>
      </CardActions>
    </Card>
  );

    const container = window !== undefined ? () => window().document.body : undefined;
    return (
    <Container maxWidth="sm" disableGutters {...swipeHandlers}>
      {redirect.trigger && (
        <Navigate to={redirect.route} replace={true} />
      )}
      <CustomSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={() => setSnackbarOpen(false)}
      />

      <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', pb: 12 }}>
        <Box
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 10,
            px: 2,
            pt: 1.75,
            pb: 1.5,
            backgroundColor: (theme) => alpha(theme.palette.background.paper, 0.95),
            backdropFilter: 'blur(10px)',
            borderBottomLeftRadius: '18px',
            borderBottomRightRadius: '18px',
            overflow: 'hidden',
            boxShadow: (theme) => (theme.palette.mode === 'dark' ? '0 6px 18px rgba(0,0,0,0.35)' : '0 10px 30px rgba(2,21,69,0.08)'),
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2.25 }}>
            <IconButton
              onClick={() => navigate(-1)}
              sx={{
                width: 40,
                height: 40,
                ml: -1,
                color: 'text.primary',
                '&:hover': { backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.08) },
              }}
            >
              <ArrowBackIcon sx={{ fontSize: 28 }} />
            </IconButton>

            <Box sx={{ minWidth: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography sx={{ fontSize: 22, fontWeight: 900, letterSpacing: '-0.02em', color: 'text.primary' }}>
                    Gestión de Usuarios
                  </Typography>
                  <Box
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 0.75,
                      px: 1.25,
                      py: 0.4,
                      borderRadius: '999px',
                      bgcolor: alpha('#238048', 0.12),
                      flexShrink: 0,
                    }}
                  >
                    <Box
                      sx={{
                        width: 6,
                        height: 6,
                        borderRadius: '999px',
                        bgcolor: '#238048',
                        animation: 'pulseDot 1.8s ease-in-out infinite',
                        '@keyframes pulseDot': {
                          '0%': { opacity: 0.35 },
                          '50%': { opacity: 1 },
                          '100%': { opacity: 0.35 },
                        },
                      }}
                    />
                    <Typography sx={{ fontSize: 10, fontWeight: 900, letterSpacing: 0.5, color: '#238048', textTransform: 'uppercase' }}>
                      {connectedUsers} en línea
                    </Typography>
                  </Box>
                </Box>
              </Box>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
            <Paper
              elevation={0}
              sx={(theme) => ({
                borderRadius: '14px',
                overflow: 'hidden',
                bgcolor: theme.palette.mode === 'dark'
                  ? alpha(theme.palette.common.white, 0.04)
                  : alpha(theme.palette.common.black, 0.02),
                boxShadow: theme.palette.mode === 'dark'
                  ? '0 2px 10px rgba(0,0,0,0.35)'
                  : '0 10px 25px rgba(2,21,69,0.06)',
              })}
            >
              <Box sx={{ position: 'relative' }}>
                <Box sx={{ position: 'absolute', left: 12, top: 0, bottom: 0, display: 'flex', alignItems: 'center', pointerEvents: 'none' }}>
                  <SearchIcon sx={{ color: 'text.secondary' }} />
                </Box>
                <InputBase
                  value={searchValue}
                  onChange={handleSearchChange}
                  placeholder="Buscar por nombre o unidad…"
                  inputProps={{ 'aria-label': 'buscar usuario' }}
                  sx={{
                    width: '100%',
                    pl: 5,
                    pr: 2,
                    py: 1.25,
                    fontSize: 14,
                  }}
                />
              </Box>
            </Paper>

            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                fullWidth
                onClick={(e) => handleTabChange(e, 'activo')}
                sx={(theme) => ({
                  py: 1,
                  borderRadius: '12px',
                  fontSize: 11,
                  fontWeight: 900,
                  letterSpacing: 1,
                  textTransform: 'uppercase',
                  bgcolor: tabValue === 'activo' ? theme.palette.success.main : 'transparent',
                  color: tabValue === 'activo'
                    ? theme.palette.getContrastText(theme.palette.success.main)
                    : (theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.text.secondary),
                  border: tabValue === 'activo' ? '1px solid transparent' : '1px solid',
                  borderColor: tabValue === 'activo' ? 'transparent' : alpha(theme.palette.divider, 0.8),
                  '&:hover': {
                    bgcolor: tabValue === 'activo'
                      ? theme.palette.success.dark
                      : alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.12 : 0.06),
                  },
                })}
              >
                Activo
              </Button>
              <Button
                fullWidth
                onClick={(e) => handleTabChange(e, 'invitado')}
                sx={(theme) => ({
                  py: 1,
                  borderRadius: '12px',
                  fontSize: 11,
                  fontWeight: 900,
                  letterSpacing: 1,
                  textTransform: 'uppercase',
                  bgcolor: tabValue === 'invitado' ? theme.palette.success.main : 'transparent',
                  color: tabValue === 'invitado'
                    ? theme.palette.getContrastText(theme.palette.success.main)
                    : (theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.text.secondary),
                  border: tabValue === 'invitado' ? '1px solid transparent' : '1px solid',
                  borderColor: tabValue === 'invitado' ? 'transparent' : alpha(theme.palette.divider, 0.8),
                  '&:hover': {
                    bgcolor: tabValue === 'invitado'
                      ? theme.palette.success.dark
                      : alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.12 : 0.06),
                  },
                })}
              >
                Pendiente
              </Button>
            </Box>
          </Box>
        </Box>

        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <Box sx={{ px: 3, pt: 1.75 }}>
          <AnimatePresence initial={false} custom={swipeDirection}>
            <motion.div
              key={tabValue}
              custom={swipeDirection}
              variants={pageVariants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={pageTransition}
            >
              {!loading && filteredUsers.length === 0 ? (
                <Box sx={{ pt: 8, textAlign: 'center' }}>
                  <PersonOffIcon sx={{ fontSize: 72, color: 'text.secondary', mb: 2 }} />
                  <Typography sx={{ fontSize: 18, fontWeight: 900, color: 'text.primary', mb: 1 }}>
                    {tabValue === 'activo' ? 'No hay usuarios activos' : 'No hay usuarios pendientes'}
                  </Typography>
                  <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.secondary' }}>
                    {tabValue === 'activo'
                      ? 'Agrega nuevos usuarios usando el botón +.'
                      : 'Luego de agregar usuarios, aparecerán aquí hasta que completen su registro.'}
                  </Typography>
                </Box>
              ) : (
                <Stack spacing={1.25} sx={{ pb: 2 }}>
                  {filteredUsers.map((user) => (
                    <Paper
                      key={user.invcode ? user.invcode : user.username}
                      elevation={0}
                      sx={{
                        p: 2,
                        borderRadius: '16px',
                        bgcolor: (theme) =>
                          theme.palette.mode === 'dark'
                            ? alpha(theme.palette.common.white, 0.04)
                            : alpha(theme.palette.common.black, 0.02),
                        boxShadow: (theme) =>
                          theme.palette.mode === 'dark'
                            ? '0 2px 10px rgba(0,0,0,0.08)'
                            : '0 10px 25px rgba(2,21,69,0.02)',
                        transition: 'transform 120ms ease, box-shadow 120ms ease',
                        '&:hover': {
                          transform: 'translateY(-1px)',
                          boxShadow: (theme) =>
                            theme.palette.mode === 'dark'
                              ? '0 6px 18px rgba(0,0,0,0.12)'
                              : '0 16px 34px rgba(2,21,69,0.04)',
                        },
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Avatar
                          sx={{
                            width: 44,
                            height: 44,
                            bgcolor: (theme) => alpha(theme.palette.success.main, theme.palette.mode === 'dark' ? 0.25 : 0.14),
                            color: (theme) => theme.palette.success.main,
                            fontWeight: 900,
                            flexShrink: 0,
                          }}
                        >
                          {getInitials(user)}
                        </Avatar>

                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography sx={{ fontSize: 14, fontWeight: 900, color: 'text.primary' }} noWrap>
                            {user?.name} {user?.lastname}
                          </Typography>
                          <Typography sx={{ fontSize: 11, fontWeight: 600, color: 'text.secondary' }} noWrap>
                            {user?.unit || '—'}
                          </Typography>
                          <Box sx={{ mt: 0.5 }}>
                            <Box
                              sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                px: 1,
                                py: 0.25,
                                borderRadius: '6px',
                                fontSize: 10,
                                fontWeight: 900,
                                letterSpacing: 0.5,
                                textTransform: 'uppercase',
                                ...getRoleChipSx(user?.role),
                              }}
                            >
                              {getRoleLabel(user?.role)}
                            </Box>
                          </Box>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
                          {tabValue === 'invitado' ? (
                            <>
                              <Button
                                size="small"
                                variant="outlined"
                                color="secondary"
                                onClick={() => resendInvite(user.invcode)}
                                sx={(theme) => ({
                                  fontWeight: 900,
                                  textTransform: 'none',
                                  ...(theme.palette.mode === 'dark'
                                    ? {
                                        borderColor: alpha(theme.palette.secondary.main, 0.6),
                                        color: theme.palette.secondary.light,
                                      }
                                    : {}),
                                })}
                              >
                                Reenviar
                              </Button>
                              <Button
                                size="small"
                                variant="outlined"
                                color="secondary"
                                onClick={() => shareInvite(user.invcode)}
                                sx={(theme) => ({
                                  fontWeight: 900,
                                  textTransform: 'none',
                                  ...(theme.palette.mode === 'dark'
                                    ? {
                                        borderColor: alpha(theme.palette.secondary.main, 0.6),
                                        color: theme.palette.secondary.light,
                                      }
                                    : {}),
                                })}
                              >
                                Compartir
                              </Button>
                              <IconButton onClick={() => showDeleteUserDialog(user)} sx={{ color: 'text.secondary' }}>
                                <DeleteIcon />
                              </IconButton>
                            </>
                          ) : (
                            <>
                              <Button
                                size="small"
                                color="secondary"
                                onClick={() => handleEditUser(user.username)}
                                startIcon={<EditIcon />}
                                sx={(theme) => ({
                                  fontWeight: 900,
                                  textTransform: 'none',
                                  ...(theme.palette.mode === 'dark'
                                    ? {
                                        border: '1px solid',
                                        borderColor: alpha(theme.palette.secondary.main, 0.45),
                                        bgcolor: alpha(theme.palette.secondary.main, 0.14),
                                      }
                                    : {}),
                                })}
                              >
                                Editar
                              </Button>
                              <IconButton onClick={() => handleMoreOptions(user)} sx={{ color: 'text.secondary' }}>
                                <MoreVertIcon />
                              </IconButton>
                            </>
                          )}
                        </Box>
                      </Box>
                    </Paper>
                  ))}
                </Stack>
              )}
            </motion.div>
          </AnimatePresence>
        </Box>
      </Box>
      <Dialog open={deleteUserDialog} onClose={closeDeleteUserDialog}>
        <DialogTitle>Confirmar eliminación</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Está seguro que desea eliminar al usuario {userToDelete ? userToDelete.name : ''} {userToDelete ? userToDelete.lastname : ''}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDeleteUserDialog} color="primary">
            Cancelar
          </Button>
          <Button onClick={() => deleteUser(userToDelete ? userToDelete.user_id : '')} color="secondary">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={pwdResetDialog} onClose={closePwdResetDialog}>
        <DialogTitle>Confirmar reinicio de contraseña</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Está seguro que desea reiniciar la contraseña del usuario {userToReset ? userToReset.name : ''} {userToReset ? userToReset.lastname : ''}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closePwdResetDialog} color="primary">
            Cancelar
          </Button>
          <Button onClick={() => resetPwd(userToReset ? userToReset.username : '')} color="secondary">
            Reiniciar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={accessRestrictModal} onClose={closeAccessRestrictModal}>
        <DialogTitle>Restringir Accesos para {selectedUser ? `${selectedUser.name} ${selectedUser.lastname}` : ''}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Seleccione los módulos a los que desea restringir el acceso:
          </DialogContentText>
          <FormGroup>
            {Object.entries(modules).map(([key, value]) => (
              <FormControlLabel
                key={key}
                control={
                  <Checkbox
                    checked={selectedModules[key] || false}
                    onChange={handleModuleChange}
                    name={key}
                  />
                }
                label={value}
              />
            ))}
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeAccessRestrictModal} color="primary">
            Cancelar
          </Button>
          <Button onClick={saveAccessRestrictions} color="secondary">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
      <Drawer
          container={container}
          anchor="bottom"
          variant="temporary"
          open={drawerShow}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          PaperProps={{ elevation: 0, sx: { backgroundColor: 'background.default' } }}
          sx={{
            display: 'block',
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: '100%',
              maxWidth: '100%',
              height: '100dvh',
              maxHeight: '100dvh',
              borderRadius: 0,
              position: 'fixed',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
            },
          }}
        >
          {newUserDrawer}
        </Drawer>
      <Drawer
        container={container}
        anchor="bottom"
        variant="temporary"
        open={moreOptsDrawer}
        onClose={handleCloseMoreOpts}
        ModalProps={{
          keepMounted: true,
        }}
        PaperProps={{ elevation: 0, style: { backgroundColor: "transparent" } }}
        sx={{
          display: 'block',
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: '100%',
            maxWidth: { xs: '100%', sm: 440 },
            left: { xs: 0, sm: '50%' },
            right: 'auto',
            transform: { xs: 'none', sm: 'translateX(-50%)' },
          },
        }}
      >
        {moreOptsDrawerContent}
      </Drawer>
      <Fab
        aria-label="add"
        sx={{
          ...fabStyle,
          backgroundColor: (theme) => (theme.palette.mode === 'dark' ? theme.palette.primary.main : '#021545'),
          color: (theme) => (theme.palette.mode === 'dark' ? theme.palette.getContrastText(theme.palette.primary.main) : 'white'),
          width: 56,
          height: 56,
          minHeight: 0,
          borderRadius: '999px',
          boxShadow: '0 10px 25px rgba(2,21,69,0.25)',
          '&:hover': {
            backgroundColor: (theme) => (theme.palette.mode === 'dark' ? theme.palette.primary.dark : '#021545'),
          },
        }}
        onClick={handleNewUser}
      >
        <AddIcon sx={{ fontSize: 32 }} />
      </Fab>
    </Container>
  );
}